import { useEffect, useState } from 'react';
import { prefixClass } from 'lib/utils';
import './ChartNavigation.scss';
import { IconButton } from 'presentation/components/ReportTable/NTSearchAndFilter/SFActions/IconButton';
import { IconClose, IconBackward, IconForward } from 'components/Icons';

import { ChartPath } from '../../types';
import { useChartContext } from '../../context/ChartContext';
import { ChartProps } from '../../types';
import { Whisper, Tooltip } from 'rsuite';

const ChartNavigation = ({ path, chartData }: { path: ChartPath[] | null; chartData: ChartProps | null }) => {
  const prefix = prefixClass('chart-navigation');
  const { handleSelect, navigationHistory, currentHistoryIndex, navigateBack, navigateForward, closeChart } =
    useChartContext();

  const handleBack = () => {
    navigateBack();
  };

  const handleForward = () => {
    navigateForward();
  };

  const handleClose = () => {
    closeChart();
  };

  return (
    <div className={prefix()}>
      <div className={prefix('back')}>
        <IconButton
          tooltipLabel={'Click to go back'}
          icon={<IconBackward />}
          status={currentHistoryIndex > 0 ? true : false}
          iconSize={28}
          onClick={handleBack}
        />
        <IconButton
          tooltipLabel={'Click to go forward'}
          icon={<IconForward />}
          status={currentHistoryIndex < navigationHistory.length - 1 ? true : false}
          iconSize={28}
          onClick={handleForward}
        />
      </div>
      <div className={prefix('path')}>
        {path &&
          path.map((p, index) => {
            const isLast = index === path.length - 1;
            return (
              <div className={prefix('path-item')} key={p?.id ?? index} onClick={() => p && handleSelect(p.id, true)}>
                {isLast ? (
                  <div className={prefix('concept')}>
                    {chartData?.total ? chartData?.name?.replace(/total\s*/i, '') : chartData?.name}
                    {chartData?.glCode && <div className={prefix('concept-gl-account')}>{chartData?.glCode}</div>}
                    {chartData?.total && <div className={prefix('concept-total')}>Total</div>}
                    {chartData?.isParent && <div className={prefix('concept-total')}>Parent</div>}
                  </div>
                ) : (
                  <Whisper trigger="hover" placement="bottom" speaker={<Tooltip>{p?.name}</Tooltip>}>
                    <span>{p?.name}</span>
                  </Whisper>
                )}
              </div>
            );
          })}
      </div>
      <div className={prefix('options')}>
        {/*         <IconButton
          tooltipLabel={'Expand Chart'}
          status={false}
          icon={<FilterUnconstrain />}
          iconTrue={<FilterConstrain />}
        /> */}
        <IconButton
          tooltipLabel={'Close Chart'}
          icon={<IconClose />}
          status={false}
          iconSize={28}
          boundary={true}
          onClick={handleClose}
        />
      </div>
    </div>
  );
};

export default ChartNavigation;
